var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16.8096C6 22.3286 10.48 26.8096 16 26.8096C21.53 26.8096 26 22.3286 26 16.8096C26 11.2886 21.53 6.80957 16 6.80957C10.48 6.80957 6 11.2886 6 16.8096ZM15.1191 20.5995C15.1191 21.0785 15.5191 21.4795 15.9991 21.4795C16.4791 21.4795 16.8691 21.0785 16.8691 20.5995V16.1795C16.8691 15.6985 16.4791 15.3095 15.9991 15.3095C15.5191 15.3095 15.1191 15.6985 15.1191 16.1795V20.5995ZM16.0109 12.1284C15.5209 12.1284 15.1309 12.5284 15.1309 13.0084C15.1309 13.4884 15.5209 13.8784 16.0009 13.8784C16.4909 13.8784 16.8809 13.4884 16.8809 13.0084C16.8809 12.5284 16.4909 12.1284 16.0109 12.1284Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.80a2e3f25e645fd3def7655d0e871c41.svg";
export { ForwardRef as ReactComponent };